import styled from 'styled-components';
import { Heading2, Heading3 } from '../../Typography/Heading';
import { windowMaxWidth } from '../breakpoints';

//------ styled for the create form step and edit modal -------
const FormStepInputFieldsWrapper = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;

  .ant-form-item {
    width: 100%;
  }

  .ant-form-item-row .ant-form-item-label {
    display: ${(props) => (props.$hideLabel ? 'none' : 'flex')};
  }

  @media (${windowMaxWidth.mobile}) {
    flex-direction: column;
    gap: 0;

    &.premium-row {
      margin-bottom: 15px;
      border-bottom: 1px solid var(--greyscale-light-grey);
    }

    .ant-form-item-row .ant-form-item-label {
      display: flex;
    }
  }
`;

const FormStepButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 40px;
  margin-top: ${(props) => (props.$hideLabel ? '0' : '20px')};
  width: 20px;

  @media (${windowMaxWidth.mobile}) {
    display: none;
  }
`;

const FormStepContentWrapper = styled.div`
  padding: 0;
`;

const FormGroup = styled.div`
  border-bottom: 1px solid var(--greyscale-dark-white);
  display: flex;
  flex-direction: column;
  padding: 20px 40px;

  &:last-child {
    border-bottom: none;
  }
`;

const FormGroupTitle = styled(Heading3)`
  margin-bottom: 20px;
  margin-top: 0;
`;

const FormGroupButtonsWrapper = styled.div`
  align-items: center;
  background: white;
  border-bottom: 1px solid var(--greyscale-dark-white);
  display: flex;
  justify-content: center;
  padding: 28px 40px;

  div > .ant-form-item {
    margin-bottom: 0;
  }

  @media (${windowMaxWidth.mobile}) {
    div > .ant-form-item {
      margin-bottom: 20px;
    }
  }
`;

//------ styled for select insured risks step -------

const Header = styled(Heading2)`
  margin-bottom: 20px;
  padding: 0 30px;
`;

const List = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 10px;
  padding: 20px 30px;

  &:not(:last-child) {
    border-bottom: 1px solid var(--greyscale-dark-white);
  }

  @media (${windowMaxWidth.mobile}) {
    gap: 30px;
  }
`;

const RiskItemHorizontalSectionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1 1 100%;
  justify-content: space-between;
  min-height: 40px;

  @media (${windowMaxWidth.mobile}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const RiskItemVerticalSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
`;

const RiskItem = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
`;

const RiskItemIconWrapper = styled.div`
  display: flex;
  padding: 10px 0;
`;

const RiskItemCheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const RiskItemRetentionAmountInputWrapper = styled.div`
  position: relative;
  width: 170px;
`;

const RiskItemAddendumInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Label = styled.div`
  cursor: pointer;
`;

const InsuredRisksContentWrapper = styled.div`
  height: 500px;
  overflow: auto;
  padding: 20px 0;
`;

const InsuredRiskTypeTitle = styled(Heading3)`
  display: block;
  flex-shrink: 0;
  margin-bottom: 0;
  margin-top: 0;
  padding: 0 30px;
  white-space: pre-wrap;

  &:not(:first-of-type) {
    margin-top: 20px;
  }
`;

// ------ styled for adding documents step -------

const CreatePolicyFileContainersWrapper = styled.div`
  max-height: 500px;
  overflow: auto;
  padding-top: 20px;
`;

// ------ styled for the connect risks step -------

const AddRisksDescription = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  margin-bottom: 10px;
`;

const TooltipWrapper = styled.span`
  display: block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const FlexButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  .ant-btn-link {
    height: 36px;
    padding: 0;
    width: 20px;

    .ant-btn-icon {
      height: 20px;
    }

    svg {
      path {
        stroke: var(--greyscale-blackish);
      }
    }

    &:not(:disabled):not(.ant-btn-disabled):hover {
      svg {
        path {
          stroke: var(--primary-oqio-red);
        }
      }
    }
  }
`;

// ------ styled for the create policy modal footer -------

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FooterRightSideWrapper = styled.div`
  .back-button {
    margin-right: 5px;
  }
`;

const PoliciesCreateEditModalLayout = {
  FormStepInputFieldsWrapper,
  FormStepButtonWrapper,
  FormStepContentWrapper,
  FormGroup,
  FormGroupTitle,
  FormGroupButtonsWrapper,
  Header,
  List,
  RiskItemHorizontalSectionWrapper,
  RiskItemVerticalSectionWrapper,
  RiskItem,
  RiskItemIconWrapper,
  RiskItemCheckboxWrapper,
  RiskItemRetentionAmountInputWrapper,
  RiskItemAddendumInputWrapper,
  Label,
  InsuredRisksContentWrapper,
  InsuredRiskTypeTitle,
  CreatePolicyFileContainersWrapper,
  AddRisksDescription,
  TooltipWrapper,
  FlexButtonWrapper,
  FooterWrapper,
  FooterRightSideWrapper
};

export default PoliciesCreateEditModalLayout;
